import { getWindowLocationOrigin } from './compatibilityUtils';

const splitUrl = (url) => {
    let base = url;
    if (url && url.length) {
        const hashParts = url.split('#');

        if (hashParts && hashParts.length > 0 && hashParts[0] && hashParts[0].length > 0) {
            base = hashParts[0];
        } else {
            //console.warn('[EGH] splitUrl() failed to split hash [#]');
        }

        const searchParts = base.split('?');
        if (searchParts && searchParts.length > 0 && searchParts[0] && searchParts[0].length > 0) {
            base = searchParts[0];
        } else {
            console.warn('[EGH] splitUrl() failed to split search [?]');
        }
    } else {
        console.error(`[EGH] splitUrl() bad url asked to parse ${url}`);
    }

    return base;
};

const isAbsolutePath = (url) => !(new RegExp(/^(http:\/\/|https:\/\/|\/\/)/g).test(url));

const getCurrentUrl = () => `${getWindowLocationOrigin()}${window.location.pathname}`;

const hrefIsActive = (unsanitizedHref) => {
    if (!unsanitizedHref) return false;

    const href = splitUrl(unsanitizedHref);

    if (isAbsolutePath(href)) {
        return `${getWindowLocationOrigin()}${href}` === getCurrentUrl();
    }

    return href === getCurrentUrl();
};

export {
    splitUrl,
    isAbsolutePath,
    getCurrentUrl,
    hrefIsActive
};



/** WEBPACK FOOTER **
 ** ./app/scripts/utils/urlUtils.js
 **/